import { api, client_code } from '@/utils'

import { Params, Response, Service } from '.'

const submit = async (params: Params): Promise<Response> => {
  try {
    // loyal.id `redeem/voucher` expects the client identifier as `code_client`
    // (see fjgs booking_redeem/service.ts). Keep `client_code` too for safety.
    const body = { ...params, code_client: client_code, client_code }
    const res = await api.post<Response>(`redeem/voucher?client_code=${client_code}`, body)
    return res.data
  } catch (e) {
    throw e
  }
}

export const service: Service = {
  submit
}
